import envStore from './env'

const StorageKeys = {
  token: `${envStore.storageKeyPrefix}_token`,
  user: `${envStore.storageKeyPrefix}_user`,
}

export default StorageKeys
